import { render } from "./OtherAssets.vue?vue&type=template&id=57963332&scoped=true"
import script from "./OtherAssets.vue?vue&type=script&lang=js"
export * from "./OtherAssets.vue?vue&type=script&lang=js"

import "./OtherAssets.vue?vue&type=style&index=0&id=57963332&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57963332"]])

export default __exports__